<template>
    <div class="employees-section">
        <div v-if="employees">

            <section class="search" >
                <div class="search-inputs">
                    <div class="loupe">
                        <svg  width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Forside" transform="translate(-129.000000, -591.000000)" stroke="#343638" stroke-width="2"><g id="Filter-employee" transform="translate(100.000000, 570.000000)"><g id="Search" transform="translate(30.000000, 19.000000)"><g id="Icon:-Search" transform="translate(0.000000, 3.000000)"><path d="M13.5,13.5 L19.5,19.5" id="Line" fill="#343638" stroke-linecap="square"></path><circle id="Oval" cx="7.5" cy="7.5" r="7.5"></circle></g></g></g></g></g></svg>
                    </div>
                    <input class="search-input" :aria-label="inputPlaceholder" v-model="searchInputValue" v-on:keyup="filterData()" :placeholder="inputPlaceholder"></input>
                </div>
            </section>
            <section class="filters" >
                <div v-for="(filter, filterSectionKey) in filters" :key="filterSectionKey" v-if="filterSectionKey !== 'positions'" class="filter-section">
                    <svg class="drop" width="15px" height="10px" viewBox="0 0 15 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Arkiv-aktuelt" transform="translate(-704.000000, -283.000000)" fill="#000"><g id="Filter-employee" transform="translate(540.000000, 260.000000)"><g id="Icon:-Arrow" transform="translate(171.500000, 27.705882) rotate(270.000000) translate(-171.500000, -27.705882) translate(166.500000, 20.205882)"><polygon id="Shape" points="9.16523618 2.078075 7.51817735 0.431016176 0.459353824 7.48983971 7.51817735 14.5486632 9.16523618 12.9016044 3.75347147 7.48983971"></polygon></g></g></g></g></svg>
                    <select v-model="selected" v-on:change="onFilterInputChange(filterSectionKey, selected)">
                        <option value="">{{dropdownLable(filterSectionKey)}}</option>
                        <option :disabled="isOptionInUse(filterSectionKey, option.term_id)" v-for="option in filter" :key="option.term_id" :value="option.term_id" v-html="option.name"></option>
                    </select>
                    <ul class="selected-values">
                        <li v-for="id in activeFilters[filterSectionKey]" :key="'sel-'+id">
                            <span class="remove" v-on:click="removeFilterValue(filterSectionKey, id)">
                                <svg width="9px" height="9px" viewBox="0 0 9 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Medarbeidere" transform="translate(-130.000000, -593.000000)" fill="#FFFFFF"><g id="Group-12" transform="translate(100.000000, 443.000000)"><g id="Group-11" transform="translate(0.000000, 60.000000)"><g id="Group-10" transform="translate(30.000000, 30.000000)"><g id="Group-8"><g id="Group-3" transform="translate(0.000000, 53.000000)"><g id="clear" transform="translate(0.000000, 7.000000)"><polygon id="Shape" points="8.95721541 0.895721541 8.06149389 0 4.47860771 3.58288617 0.895721541 0 0 0.895721541 3.58288617 4.47860771 0 8.06149389 0.895721541 8.95721541 4.47860771 5.37432925 8.06149389 8.95721541 8.95721541 8.06149389 5.37432925 4.47860771"></polygon></g></g></g></g></g></g></g></g></svg>
                            </span>
                            <span class="label" v-html="filterLabelById(filterSectionKey, id)"></span>
                        </li>
                    </ul>
                </div>
            </section>
            <ul v-if="filteredEmployees"
                class="page-employees-rel clearfix">
                <li class="cell" v-for="employee in filteredEmployees.slice(0, page * perPage)" :key="employee.id">
                    <singleemployee :postdata="employee"></singleemployee>
                </li>
                <div class="load-more-area">
                    <div class="visibility-dot"
                        v-observe-visibility="{
                            callback: loadMoreVisible,
                            throttle: 150,
                        }"
                    ></div>
                    <button class="load-more" v-if="filteredEmployees.length !== 0 && filteredEmployees.length > (page * perPage)" @click="loadMore">LOAD MORE</button>
                </div>
                <p v-if="filteredEmployees.length === 0" class="no-results">{{noResultsMessage}}</p>
            </ul>

        </div>
        <preloader v-if="!employees"/>
    </div>
</template>

<script>
    import preloader from './components/preloader.vue';
    import catDropdown from './components/categoryList.vue';
    import singleEmploye from './components/singleEmploye.vue';

    import axios from 'axios';
    import _uniqBy from 'lodash.uniqby';
    import _uniq from 'lodash.uniq';
    import _orderby from 'lodash.orderby';
    //import {TweenMax, TimelineMax} from "gsap";
    /**
        The filteres logic:
        overall logic should be:
        Expertise can be selected IF:
        - No roles are selected.
        - Partner role is selected.
        - Specialist Partner is selected.

        If any other role is selected, the expertise should be cleared and not possible to select.
    */

    export default {
        name: 'Employees',
        components: {
            'preloader' : preloader,
            'catdropdown' : catDropdown,
            'singleemployee' : singleEmploye,
        },
        data() {
            return {
               employees: null,
               filteredEmployees: [],
               filters: null,
               page: 1,
               perPage: 16,
               inputPlaceholder: theme_data.strings.search_placeholder_home,
               noResultsMessage: theme_data.strings.nothing_to_show,
               searchInputValue: '',
               selected:'',
               disableRoles: false,
               activeFilters: {
                    branches: [],
                    roles: [],
                    positions: [],
                    specialisations: []
               }
            }
        },
        computed:{
            specializedRoles() {
                let roles = [];
                const VM = this;
                if(VM.filters.roles.length){
                    roles = VM.filters.roles.filter( it => {
                        if(it.name.toLowerCase() === 'partner' || it.name.toLowerCase() === 'specialist partner') return it;
                    })
                }
                return roles;
            },
            disableAreaExpertise() {
                let disable = false;

                if(this.activeFilters.roles.length){
                    const specializations = this.specializedRoles.map( it => it.term_id);
                    // If active filteres roles has any different roles than speclized rooles then false.
                    if(this.activeFilters.roles.some( it => !specializations.includes(it))) disable = true;
                }
                return disable;
            }
        },
        mounted() {
            this.loadData();
        },
        watch:{
            'activeFilters.roles' :{
                handler(val, oldVal){
                    const VM = this;
                    // IF NO ROLES SELECTED, clear specialisations.
                    if(!val.length && oldVal.length && VM.activeFilters.specialisations.length){
                        VM.activeFilters.specialisations = [];
                        VM.filterData();
                    }

                    if (val.length && VM.disableAreaExpertise) {
                        VM.activeFilters.specialisations = [];
                        VM.filterData();
                    }
                },
            },
            'activeFilters.specialisations' :{
                handler(val, oldVal){
                    const VM = this;
                    // If no roles selected add partner and specialist partner
                    if (!VM.activeFilters.roles.length && val.length && !oldVal.length) {
                        VM.activeFilters.roles = this.specializedRoles.map( it => it.term_id);
                        VM.filterData();
                    }
                },
            },
        },
        methods: {
            loadMoreVisible(visible){
                if(visible){
                    this.loadMore();
                }
            },
            loadMore(){
                this.page = this.page + 1;
            },
            enterAnimationEmployee(el, done){
                done;
/*                 TweenMax.fromTo(el, 2,
                    { opacity: 0, height: 0, scale: 0 },
                    { opacity: 1, height: '100%', scale: 1, onComplete: done }
                )  */
            },
            leaveAnimationEmployee(el, done){
                done;
                //TweenMax.to(el, 2, { opacity: 0, height: 0, scale: 0, onComplete: done } )
            },
            makeData(data){
                this.employees = data;
                this.filteredEmployees = data;
                this.buildFilters(data);
            },

            apiGetData(){
                const self = this;
                axios.get( theme_data.api+'bahr/v2/load_employees_cq/', {
                    params: {
                        lang: theme_data.language,
                        version: theme_data.employee_versions
                    }
                })
                .then(response => {
                    if(response.data.posts_data){
                        let posts = response.data.posts_data || [];
                        posts = _orderby(posts, ['first_name'], ['asc']);
                        self.saveLocalForge(posts, response.data.cache_ver);
                        self.makeData(posts);
                    }else{
                        console.warn('Error loading Emplooyees')
                    }

                })
            .catch(error => console.warn('Error!', error));
            },
            loadData( storedData ) {
                const self = this;
                const cacheServer = theme_data.employee_versions;
               // console.log(storedData);
                self.loadLocalStorage().then( (storageData) => {
                    if(storageData &&  storageData.version === cacheServer){
                        self.makeData(storageData.employees);
                    }else{
                        self.apiGetData()
                    }
                })

            },
            buildFilters(apiResposeData) {
                this.filters = apiResposeData.reduce((acc, item) => {
                    //console.log(item)
                    /*acc.branches = _uniqBy([
                        ...acc.branches,
                        ...item.branch.map(e => ({ term_id: e.term_id, name: e.name }))
                        ], 'term_id');*/
                    acc.roles = _uniqBy([
                        ...acc.roles,
                        ...item.role.map(e => ({ term_id: e.term_id, name: e.name, order: Number(e.order), term_order: Number(e.term_order) }))
                        ], 'term_id');
                    acc.positions = _uniqBy([
                        ...acc.positions,
                        ...item.position.map(e => ({ term_id: e.termi_id, name: e.name, order: e.order, term_order: e.term_order }))
                        ], 'term_id');
                    acc.specialisations = _uniqBy([
                        ...acc.specialisations,
                        ...item.specialisation.map(e => ({ term_id: e.term_id, name: e.name, order: Number(e.order), term_order: Number(e.term_order) }))
                        ], 'term_id');
                    return acc;
                }, {
                    /*branches: [],*/
                    roles: [],
                    positions: [],
                    specialisations: []
                });
                this.filters.specialisations = _orderby(this.filters.specialisations, [ 'name'], ['asc']);
                this.filters.roles = _orderby(this.filters.roles, [ 'term_order'], ['asc']);

            },
            dropdownLable(key) {
                return theme_data.strings[key];
            },
            onFilterInputChange(filterKey, val) {
                this.selected = ''; // reset dropdowns after selection
                this.searchInputValue = ''; // reset search input
                this.activeFilters[filterKey] = _uniq([...this.activeFilters[filterKey], val]);
                this.filterData('change');
            },
            filterLabelById(filterSectionKey, id) {
                return this.filters[filterSectionKey].filter(term => term.term_id === id)[0].name;
            },
            removeFilterValue(filterSectionKey, id) {
                this.activeFilters[filterSectionKey] = this.activeFilters[filterSectionKey].filter(term_id => term_id !== id);
                this.searchInputValue = ''; // reset search input
                this.filterData('remove');
            },
            isOptionInUse(filterSectionKey, id) {
                //console.log(this.disableRoles && filterSectionKey == 'specialisations');
                if(this.disableRoles && filterSectionKey == 'roles') return true;
                if(this.disableAreaExpertise && filterSectionKey == 'specialisations') return true;
                return this.activeFilters[filterSectionKey].includes(id);
            },
            filterData(wbere = 'default') {
                this.page = 1;
                this.filteredEmployees = this.employees.filter(post => {
                    const { branches, positions, roles, specialisations } = this.activeFilters;

                    if(branches.length > 0) {
                        const matches = post.branch.filter(term => {
                            return branches.includes(term.term_id);
                        });
                        if(matches.length !== branches.length) return false;
                    }

                    if(roles.length > 0) {
                        const matches = post.role.filter(term => {
                            return roles.includes(term.term_id);
                        });

                        if (matches.length === 0) return false;
                    }

                    if(positions.length > 0) {
                        const matches = post.position.filter(term => {
                            return positions.includes(term.term_id);
                        });
                        if(matches.length !== positions.length) return false;
                    }
                    
                    if(specialisations.length > 0) {
                        const matches = post.specialisation.filter(term => {
                            return specialisations.includes(term.term_id);
                        });
                        if(matches.length !== specialisations.length) return false;
                    }

                    if(this.searchInputValue !== '') {
                        const checkIn = post.first_name + ' ' + post.lastname;
                        if(checkIn.toLowerCase().indexOf(this.searchInputValue.toLowerCase()) === -1) {
                            return false;
                        }
                    }

                    return true;
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/js/vue/Employees.vue?848f5996